(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["idk-custom-rug"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('idk-custom-rug')) {
  customElements.define('idk-custom-rug', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const material = this.querySelector('[data-idk-material]');
      const construction = this.querySelector('[data-idk-construction]');
      if (!material || !construction) return;
      const sync = () => {
        const leather = material.selectedOptions[0]?.dataset.material === 'leather';
        const stitched = construction.querySelector('[data-construction="leather"]');
        if (leather) {
          if (construction.value !== stitched.value) this.previousConstruction = construction.value;
          construction.value = stitched.value;
        } else if (this.wasLeather && construction.value === stitched.value) {
          construction.value = this.previousConstruction || construction.options[0].value;
        }
        for (const option of construction.options) option.disabled = leather && option !== stitched;
        const hint = this.querySelector('[data-idk-leather-note]');
        if (hint) hint.hidden = !leather;
        this.wasLeather = leather;
      };
      material.addEventListener('change', sync, {signal:this.controller.signal});
      construction.addEventListener('change', sync, {signal:this.controller.signal});
      sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
